import { PrimaryButton } from 'components/v2/buttons';
import PrimeCheckbox from 'components/v2/controls/PrimeCheckbox';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import styled from 'styled-components';
import { HyperLink, TextSmallDescription } from 'styles/Styles.styled';
import { CheckBoxPanel } from 'styles/v2/Styles.styled';
import logo from '../../images/EPD-logo.svg';

type TProps = {
  isOpened: boolean;
  onTermsAccept: any;
};

const TermsAndConditionsDialog = ({ isOpened, onTermsAccept }: TProps) => {
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);

  const headerContent = (
    <TextSmallDescriptionHeader>Updated Data Network General Terms and Conditions</TextSmallDescriptionHeader>
  );

  const footerContent = (
    <div>
      <PrimaryButton label="Proceed to the Portal" onClick={() => onTermsAccept(termsAccepted)} disabled={!termsAccepted} />
    </div>
  );

  return (
    <Dialog
      header={headerContent}
      closable={false}
      visible={isOpened}
      style={{ width: '50vw' }}
      footer={footerContent}
      onHide={() => {}}
    >
      <StyledContentContainer>
        <InformationContainer>
          We have updated our{' '}
          <HyperLink href="https://www.environdec.com/general-terms">Data Network General terms and conditions</HyperLink>{' '}
          which applies to all users of data in EPD International, based on the right on the current terms. Please read
          through the updated terms and agree to them by checking the box below to proceed to the EPD Portal.
          <br />
          <br />
          In case of questions please contact our support team{' '}
          <HyperLink href="mailto:support@environdec.com">support@environdec.com</HyperLink>.
        </InformationContainer>
        <TermsAndConditionsContainer>
          <b>GENERAL TERMS - USE OF DATA NETWORK</b>
          <br />
          <br />
          <b>VERSION MAY 2024</b>
          <br />
          <br />
          <ol className="main-list">
            <li>
              INTRODUCTION
              <br />
              <p>
                These GENERAL TERMS- USE OF DATA NETWORK (“General terms”) apply for the use of the Data Network (as defined
                below) provided by EPD International AB, address Box 21060, 100 31 Stockholm, Sweden.
              </p>
              <p>
                An “EPD” (Environmental Product Declaration) is an environmental product declaration that provides objective,
                third-party verified and comparable information made under the International EPD System, held and operated by
                EPD International AB. All approved EPDs are published via the International EPD Systems' Data Network.
              </p>
            </li>{' '}
            <li>
              DATA NETWORK
              <br />
              <p>
                The EPD International data network is available at www.environdec.com and all subdomains and related
                services, such as but not limited to www.data.environdec.com, www.portal.environdec.com, EPD Library, PCR
                Library, (hereafter jointly the “Data Network”) provided by EPD International AB as part of EPD International
                AB’s operation of the International EPD System, a leading global EPD programme for Environmental Declarations
                under which companies and associations may transparently declare the environmental impact of products and
                services from a life cycle perspective.
              </p>
              <p>
                An “EPD” (Environmental Product Declaration) is an environmental product declaration that provides objective,
                third-party verified and comparable information made under the International EPD System, held and operated
                EPD International AB. All approved EPDs are published via the International EPD Systems' Data Network.
              </p>
              <p>The use of the Data Network is subject these General terms.</p>
              <p>
                By accessing and using information and data on the Data Network the User (the “User” defined as any person
                accessing and using the data shared on the Data Network) accepts these General terms without restriction and
                reserve.
              </p>
              <p>
                Thus, each User acknowledges that he/she has read and understood these General terms and agrees to be bound
                by them by the continued use of the Data networ. First time visitors to{' '}
                <HyperLink href="https://www.environdec.com">www.environdec.com</HyperLink> are displayed with the following
                text message “By accessing or using this website, you agree to the use of cookies as well as the General
                terms of use. Read more”{' '}
                <HyperLink href="https://www.environdec.com/general-terms">www.environdec.com/general-terms</HyperLink> and
                the General Programme Instructions (GPI), [
                <HyperLink href="https://environdec.com/resources/documentation#generalprogrammeinstructions">
                  https://environdec.com/resources/documentation#generalprogrammeinstructions
                </HyperLink>
                ].
              </p>
              <p>
                Access to www.portal.environdec.com requires a license which can be obtained by the User registering at{' '}
                <HyperLink href="https://portal.environdec.com">www.portal.environdec.com</HyperLink>.
              </p>
              <p>
                Information and data on the Data Network to which EPD International AB grants the User access are
                copyright-protected. All rights are reserved for the provider.
                <dd>
                  <ol start={1}>
                    <li>
                      All data included in an EPD is owned by the original EPD owner. The EPD owner is usually the
                      manufacturer of the affected product or a trade association in case of sectoral EPD.
                    </li>
                    <li>
                      Ownership to data which is used for creating an EPD (for example LCI/A background data) will remain
                      with the provider of such data.
                    </li>
                    <li>When the User uses data included in an EPD there will be no transfer of ownership to said data.</li>
                    <li>
                      The User may only use the data included in an EPD as it is. The User is not allowed to deconstruct the
                      EPD data accessed on the Data Network, nor to use them for the creation of another data product.
                    </li>
                    <li>
                      The User is not allowed to redistribute or sell the EPD data or any parts thereof. In other words, the
                      User may not create or distribute data products of their own.
                    </li>
                    <li>
                      All intellectual property rights and equivalent rights to the Data Network, including the underlying
                      software, illustrations, logos, trademarks, brand names, etc. are the exclusive property of EPD
                      International AB or IVL Swedish Environmental Institute Ltd, as applicable. Use of such intellectual
                      property rights and equivalent rights is only authorized with the explicit prior consent in writing of
                      EPD International AB or IVL Swedish Environmental Institute Ltd.
                    </li>
                  </ol>
                </dd>
              </p>
              <p>
                EPD International AB has the right to distribute data from the Data Network free of charge for all users and
                uses to other EPD access points, commercial EPD databases etc. including but not limited to the ECO Portal
                provided by ECO Platform.
              </p>
              <p>
                The User may not make the application or software on the Data Network available to any third parties,
                including not to transfer, sell, license or rent it to third parties. Nor may the User decompile, reverse
                engineer, or modify the application or software on the Data Network. Moreover, the User is prohibited from
                removing or circumventing the technical provisions for protecting the application and software on the Data
                Network.
              </p>
            </li>
            <li>
              TRADEMARK ETC.
              <p>
                When using data accessed on the Data Network the User must be transparent concerning data origin and quality
                by communicating that such data is coming EPD International AB and by stating the source of the data (i.e
                that the data is sourced from the International EPD System) together with the following trademark of the
                International EPD System:
              </p>
              <img width={300} src={logo} alt="EPD International logo" />
            </li>
            <li>
              ACCESS, LIABILITY ETC.
              <p>
                EPD International AB cannot guarantee that the Data Network will always be available without interruption or
                defect or that the Data Network will be free from viruses. All the information and data on the Data Network
                is published in good faith and for information purpose only. EPD International AB does not make any
                representations or warranties about the completeness, reliability or accuracy of information and data on the
                Data Network. Any action which a User takes upon the information and data on the Data Network is strictly at
                the User’s own risk, and EPD International AB is not liable for any losses and damages in connection with the
                use of information or data on the Data Network. The User’s downloads or other use of such information or data
                is made under the sole responsibility of the User.
              </p>
              <p>
                EPD International AB disclaims any and all liability for all damages (whether direct and/or indirect damages;
                such as consequential damages, loss of income, loss of business or profit, loss of reputation) occurring
                under the User’s use of the Data Network. EPD International AB shall consequently neither be liable for any
                loss of data, damage caused by computer viruses or interference on the User’s or third party’s computer.
              </p>
              <p>
                Any damage caused by the User’s misuse of the data or information included on the Data Network or caused by
                the User’s violation of these General terms shall be compensated by the User. Neither EPD International AB or
                the owners of EPDs have any liability of any kind due to User’s misuse of data or information included on the
                Data Network or User’s violation of these General terms, and the User shall indemnify and hold EPD
                International AB harmless against all liabilities, claims, damages and expenses of every kind and character
                in that respect.
              </p>
              <p>
                The User may via the Data Network access other websites by using hyperlinks to these sites. While EPD
                International AB strive to provide links to relevant websites for the administration of the International EPD
                System, EPD International AB has no control over the content or nature of these websites. EPD International
                AB therefore takes no liability of any kind in relation to the User’s access or use of such websites.
              </p>
            </li>
            <li>
              TERMINATION AND CONTROVERSY
              <p>
                EPD International AB may terminate the User’s access to the Data Network with immediate effect and with no
                previous notice if the User breaches any of these General terms, or if the User - in EPD International’s
                reasonable opinion - is acting improperly towards EPD International AB or in breach of any laws or
                regulations. The User is thereafter prevented from accessing and using the Data Network.
              </p>
              <p>
                EPD International AB reserves the right to temporarily or permanently block the Data Network at any time
                without any previous notice.
              </p>
              <p>
                If the rights granted to the User under these General terms would terminate, the User shall immediately cease
                using the Data Network, and destroy any and all entry codes and/or passwords to the Data Network. The User
                must delete any data downloaded through the Data Network and undertakes not to use them again.
              </p>
              <p>
                EPD International AB reserves the right to modify these General terms at any time. In case of modification
                the User will receive a notification and the User’s written consent of the modified terms will be required
                for the User’s right to access and use of the Data Network.
              </p>
              <p>
                These General terms are governed by Swedish law. Any dispute, controversy or claim arising out of or in
                connection with the General terms, or the breach, termination or invalidity thereof, shall be finally settled
                by arbitration administered by the Arbitration Institute of the Stockholm Chamber of Commerce (the “SCC”).
                The Rules for Expedited Arbitrations shall apply, unless the SCC in its discretion determines, taking into
                account the complexity of the case, the amount in dispute and other circumstances, that the Arbitration Rules
                shall apply. In the latter case, the SCC shall also decide whether the Arbitral Tribunal shall be composed of
                one or three arbitrators. The seat of arbitration shall be Stockholm, Sweden. The language to be used in the
                arbitral proceedings shall be English.
              </p>
            </li>
            <li>
              PRIVACY
              <p>
                This privacy policy intends to inform all users of the Data Network as well as to inform of the principles
                that govern for example newsletters sent by EPD International AB (“EPD International” or “we”). Our contact
                information is found below, in section 6.2.6, as well as on{' '}
                <HyperLink href="https://www.environdec.com/contact-us">www.environdec.com/contact-us</HyperLink>.
              </p>
              <li>
                <ol className="sub-list">
                  <li style={{ fontWeight: '700' }}>What personal data do we process?</li>
                  <ol className="sub-sub-list">
                    <li>
                      EPD International collects and processes such personal data that you submit to us when creating a user
                      account on the website, registering an EPD, applying to become a PCR moderator, LCA consultant or
                      applying to become an individual verifier. The personal data collected are, where applicable, username,
                      e-mail address, organisation and address. This processing of personal data is based on you giving your
                      consent to the processing, in connection with submitting the personal data.
                    </li>
                    <li>
                      When signing up for our newsletters or when you register on any of our courses, seminars, or other
                      events that we arrange we process personal data that you provide through filling in assigned forms. The
                      personal data collected are, where applicable, name, e-mail address, organisation, address, and dietary
                      preferences. This processing of personal data is based on you giving your consent to the processing, in
                      connection with submitting the personal data.
                    </li>
                    <li>
                      When registering an EPD, applying to become PCR moderator, registering as an LCA consultant, or
                      applying to become an approved individual verifier, the name and e-mail address of the contact person
                      is publicly displayed at www.environdec.com. We have found that this processing is motivated, to enable
                      a transparent procedure for PCR development and to enable stakeholders to contact an EPD owner about
                      the document and have thus found that our interest in processing the data is legitimate.
                    </li>
                    <li>
                      We use the tool Google Analytics in order to measure traffic on the Website and evaluate the functions
                      of the Website. This means that personal data about you, i.e. your IP-address is collected, as well as
                      indirect personal data about, you regarding information on how long your visit on the Website has been
                      and what pages you have visited, will be transferred to Google Inc. (”Google”). Before initiating this
                      kind of processing, we have conducted a weighing of interests and concluded that this processing is
                      necessary for us to evaluate our business in order to offer the best possible experience when visiting
                      the Website.
                    </li>
                    <li>
                      We sometimes publish photographs on the Website, from events we arrange or participate in. These
                      photographs may be of such nature that they constitute personal data. Before publishing photographs, we
                      always examine them and evaluate if publishing of the photograph may be integrity sensitive. If we find
                      that this is not the case, we publish the photograph, for the purpose of informing about the event or
                      otherwise circumstances under which the photograph was taken.
                    </li>
                    <li>The Website uses cookies, in accordance with our cookie policy, which is found below.</li>
                    <li>
                      During PCR development, the PCR moderator sends us a list of identified stakeholders for the PCR
                      stakeholder consultation group. These stakeholders, as representatives of different organisations, are
                      contacted to enable them to be informed about and to be given a possibility to comment on the draft
                      document that may be relevant for their work. This entails that processing of personal data is a
                      necessary measure. We have limited the amount of collected and processed personal data to a minimum and
                      have made the assessment that this processing is motivated and that our interest of processing it is
                      legitimate.
                    </li>
                  </ol>
                  <li style={{ fontWeight: '700' }}>The processing</li>
                  <ol className="sub-sub-list">
                    <li>
                      EPD International is part of a group, in which IVL Swedish Environmental Research Institute is the
                      parent company. The group also consists of other subsidiaries such as (but not limited to) BASTAonline
                      AB (”BASTA”) and eBVD i Norden AB (”eBVD”). EPD International, IVL, and IVL’s subsidiaries are joint
                      personal data controllers for the processing of personal data conducted within the group. This applies
                      to personal data processed for our newsletters or when registering on courses, seminars, or other
                      events that we arrange. This means that your personal data will be shared and jointly stored within the
                      group. You will, however, only receive the newsletters and other mailings that you have signed up for.
                      What is mentioned in this policy regarding EPD International also covers IVL and its subsidiaries, and
                      you can enforce your rights against any of the companies.
                    </li>
                    <li>
                      Regarding all other processing of personal data than the ones described above, EPD International is the
                      sole controller.
                    </li>
                    <li>
                      EPD International is cautions of your integrity and right to privacy, and it is therefore of key
                      importance for EPD International that all processing of your personal data is made in a safe and proper
                      manner, in accordance with the applicable laws and in a manner that ensures safe and appropriate
                      processing. For this reason, your personal data will only be processed for the purposes specified when
                      the personal data was collected, unless you have been informed otherwise and have been given the
                      opportunity to consent, if applicable.
                    </li>
                    <li>
                      If you want to know what personal data EPD International processes about you, you have the right to
                      request access to these personal data. You also have the right to request rectification or erasure of
                      incorrect personal data. If you are of the opinion that EPD International’s processing of your personal
                      data is incorrect, you may request restriction of our processing of the personal data or object to the
                      processing. You may also have the right to so-called "data portability". If you want to use any of your
                      granted rights, please contact us on the information given below in section 2.6.
                    </li>
                    <li>
                      Other than what is mentioned above, EPD International will not transfer your personal data to any third
                      party or transfer them to a country other than Sweden, unless you are given information about this and
                      is given the opportunity to consent, if applicable. For newsletters, we always use technology that
                      ensures that addresses of the recipients are not shown.
                    </li>
                    <li>
                      If you have any comments about our processing of your personal data, if you want to use any of your in
                      section 2.4 granted rights or if you for any other reason wish to contact us, we are reached using the
                      following information
                    </li>
                    <p>
                      EPD International
                      <br />
                      Swedish companies reg. no 556975-8286
                      <br />
                      Box 21060 100 31 Stockholm
                      <br />
                      <HyperLink href="mailto:support@environdec.com">support@environdec.com</HyperLink>
                    </p>
                    <li>
                      You also have the right to contact the responsible supervisory authority, which is the Swedish Data
                      Protection Authority. Contact information is found on their website, www.datainspektionen.se.
                    </li>
                  </ol>
                  <li style={{ fontWeight: '700' }}>For how long to we store the personal data?</li>
                  <ol className="sub-sub-list">
                    <li>
                      The term under which we process your personal data depends on the processing – meaning that processing
                      is carried out until the purpose of the processing has been reached. This assessment is made through
                      the following principles.
                    </li>
                    <li>
                      Processing of personal data for mailings and newsletters will be made for as long as you wish to
                      receive them. The easiest way for us to become aware that you no longer wish to receive our mailings is
                      if you opt-out from further mailings in accordance with the information provided in each mailing.
                      However, we are regularly follow up our mailings, and should we discover that you have not been opening
                      our mailings, or if you have in other ways been passive regarding them for a continuous period of one
                      year, we reserve the right to erase your personal data from our systems. You are however always more
                      than welcome to re-sign up.
                    </li>
                    <li>
                      The personal data we collect for seminars, courses and other events are needed in order for us to be
                      able to administrate the event, and under some circumstances in order to send information or handouts
                      before or after the event. We therefore keep your personal data until thirty days from the event have
                      passed.
                    </li>
                    <li>
                      Personal data associated with your user account on the website will be stored until you request them to
                      be deleted. If you have in other ways been passive regarding them for a continuous period of one year,
                      we reserve the right to erase your personal data from our systems. You are however always more than
                      welcome to re-sign up.
                    </li>
                    <li>
                      Personal data supplied with registering an EPD, applying to become a PCR moderator, applying to become
                      an approved individual verifier will be stored and processed for as long as the EPD remains published,
                      you are still the appointed PCR moderator, or while you remain as an approved individual verifier of an
                      EPD. We reserve the right to erase your personal data from our systems in one year after these criteria
                      are no longer fulfilled.
                    </li>
                    <li>
                      Personal data collected from stakeholders during PCR and GPI development will be stored for one year
                      after the publication of the PCR and GPI.
                    </li>
                  </ol>
                </ol>
              </li>
            </li>
            <li>
              MISCELLANEOUS
              <p>
                This privacy policy may be updated without prior notice. In case of any significant changes or updates, EPD
                International will post a notification on the Website.
              </p>
            </li>
            <li>
              COOKIES
              <p>
                A cookie is a small text file stored on the visitor's computer and containing information. Cookies are
                usually used to improve the site for the user.
              </p>
              <p>
                At www.environdec.com, cookies are used to provide access to different functionality, such as logging in,
                remembering if the user accepts cookies and to measure and analyse site traffic with Google Analytics.
              </p>
              <p>
                If you do not want to use cookies, you can change the settings of your web browser to avoid them. See your
                browser's help pages for more information. Not allowing cookies may limit some functionality on the site.
              </p>
            </li>
          </ol>
        </TermsAndConditionsContainer>
        <AcceptTermsCheckBoxPanel>
          <PrimeCheckbox
            id="agreeWithTermsAndConditions"
            name="agreeWithTermsAndConditions"
            value={termsAccepted}
            label="I have read and accept the service agreement"
            labelStyle={{ fontSize: '14px' }}
            boxStyle={{ margin: 0 }}
            onChange={(event: any) => {
              setTermsAccepted(event.checked);
            }}
          />
        </AcceptTermsCheckBoxPanel>
      </StyledContentContainer>
    </Dialog>
  );
};

const StyledContentContainer = styled.div`
  padding: 0 2rem 2rem 2rem;
  ${(props) => props.theme.fonts.textSmall}
`;

const InformationContainer = styled.div`
  background-color: ${(props) => props.theme.colors.elementsFilledInput};
  padding: 1rem;
`;

const TermsAndConditionsContainer = styled.div`
  padding: 1rem;
  margin-top: 1rem;
  border: 1px solid ${(props) => props.theme.colors.elementsInputBorder};

  p {
    font-weight: normal;
  }

  ul {
    margin-top: 0;
    padding-left: 1rem;
  }

  ol {
    list-style-type: decimal;
    margin-top: 0;
    padding-left: 1rem;
  }
  ol > li {
    padding-top: 1rem;
  }
  ol > li:first-child {
    padding-top: 0;
  }

  ol.main-list {
    counter-reset: item;
    list-style-type: none;
    padding-left: 0;
  }
  ol.simple {
    counter-reset: item;
    list-style-type: none;
    padding-left: 0;
  }
  ol.main-list > li {
    counter-increment: item;
    font-weight: 700;
  }
  ol.main-list > li:first-child {
    padding-top: 1rem;
  }
  ol.main-list > li:before {
    content: counter(item) '. ';
  }
  ol.sub-list {
    counter-reset: subitem;
    list-style-type: none;
    padding-left: 0;
  }
  ol.sub-list > li {
    counter-increment: subitem;
    font-weight: 400;
  }
  ol.sub-list > li:first-child {
    padding-top: 1rem;
  }
  ol.sub-list > li:before {
    content: counter(item) '.' counter(subitem) '. ';
  }
  ol.sub-sub-list {
    counter-reset: subsubitem;
    list-style-type: none;
    padding-left: 0;
  }
  ol.sub-sub-list > li {
    counter-increment: subsubitem;
    font-weight: 400;
  }
  ol.sub-sub-list > li:first-child {
    padding-top: 1rem;
  }
  ol.sub-sub-list > li:before {
    content: counter(item) '.' counter(subitem) '.' counter(subsubitem) '. ';
  }
`;

const AcceptTermsCheckBoxPanel = styled(CheckBoxPanel)`
  background-color: ${(props) => props.theme.colors.primaryOrange01};
  .p-checkbox,
  .p-checkbox .p-checkbox-box {
    width: 14px;
    height: 14px;
  }
  .p-checkbox .p-checkbox-box .p-checkbox-icon {
    font-size: 10px;
    font-weight: 700;
  }
`;

const TextSmallDescriptionHeader = styled(TextSmallDescription)`
  text-transform: uppercase;
`;

export default TermsAndConditionsDialog;
